import getters from "@/store/modules/digital_human/getters";
import mutations from "@/store/modules/digital_human/mutations";
import actions from "@/store/modules/digital_human/actions";
import { DigitalHumanState } from "@/store/modules/digital_human/interfaces";
import { IApp } from "@/interfaces";
import digital_human_setting from "@/utils/digital_human";

export default {
  namespaced: true,
  state: (): DigitalHumanState => ({
    loading: false,
    bot_background: false,
    bot_setting: digital_human_setting[IApp.Portals.HCMS],
    hygen_peer_connection: null,
    hygen_render_id: 1,
    hygen_session_id: null,
    hygen_session_info: null,
    init_hygen_session_error: null,
    session_initialized_successfully: false
  }),
  getters: getters,
  mutations: mutations,
  actions: actions
};
